import { OrderPayablesProcessParameters } from "../OrderPayablesProcessParameters";
import { OrderPayablesProcessPostPayables } from "../OrderPayablesProcessPostPayables";
import { OrderPayablesProcessPrintChecks } from "../OrderPayablesProcessPrintChecks";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProcessStepper extends Layout {
    layoutParameters: OrderPayablesProcessParameters;
    layoutPayments: OrderPayablesProcessPrintChecks;
    layoutPostPayables: OrderPayablesProcessPostPayables;
    orderPayablesParametersStep: Step;
    orderPayablesPaymentsStep: Step;
    orderPayablesPostStep: Step;
    orderPayablesProcessStepper: Stepper;
    orderPayablesSummaryStep: Step;
}
